import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import { useAIAuthHeaders } from '@/features/ai-agents/shared/use-ai-auth-headers';
import { getQueryParam } from '@/utils/browser';
import { resoleRoutes } from '@/features/ai-agents/shared/routes-resolver';

export type AiImageResult =
  | {
      type: 'limit_or_error';
      urls: string[];
      limitReached: boolean;
      error: boolean;
    }
  | {
      type: 'image';
      metadata: {
        aspect_ratio: string;
        cdn_url: string;
        image_size: string;
        input_image: string;
        model: string;
        prompt: string;
        timestamp: string;
      };
      path: string;
      url: string;
    };

export function useImageGen() {
  const isLocalAiRoute = getQueryParam(`local-ai`) === `1`;
  const { headers } = useAIAuthHeaders(isLocalAiRoute);
  const { post, loading } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    ...{
      ...(isLocalAiRoute ? { headers } : {}),
      credentials: `include`,
      cachePolicy: CachePolicies.NO_CACHE,
    },
  }));

  function getImage(params: string): Promise<AiImageResult> {
    return post(resoleRoutes(isLocalAiRoute, routes.imageAiGen), params);
  }
  return { getImage, loading };
}
